var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageSource = exports.ToolbarAndroid = exports.TabBarItemIOS = exports.TabBarItem = exports.Button = exports.default = void 0;

var _createIconSet = _interopRequireDefault(require("./lib/create-icon-set"));

var _MaterialIcons = _interopRequireDefault(require("./glyphmaps/MaterialIcons.json"));

var iconSet = (0, _createIconSet.default)(_MaterialIcons.default, 'Material Icons', 'MaterialIcons.ttf');
var _default = iconSet;
exports.default = _default;
var Button = iconSet.Button;
exports.Button = Button;
var TabBarItem = iconSet.TabBarItem;
exports.TabBarItem = TabBarItem;
var TabBarItemIOS = iconSet.TabBarItemIOS;
exports.TabBarItemIOS = TabBarItemIOS;
var ToolbarAndroid = iconSet.ToolbarAndroid;
exports.ToolbarAndroid = ToolbarAndroid;
var getImageSource = iconSet.getImageSource;
exports.getImageSource = getImageSource;